import { AppRoute } from '@app/core/routing/AppRoute';
import { DailymotionApiKeyConnectPage } from '@app/modules/social-export/platforms/dailymotion/connect/DailymotionApiKeyConnectPage';
import { PlatformSettingsPage } from '@app/modules/social-export/screens/manage/platforms/PlatformSettingsPage';
import { SocialExportManagePage } from '@app/modules/social-export/screens/manage/SocialExportManagePage';
import { SocialExportUploadedPage } from '@app/modules/social-export/screens/uploaded/SocialExportUploadedPage';
import { Switch, useRouteMatch } from 'react-router-dom';

export function AdminSocialExportRoutes() {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <AppRoute path={`${path}/uploaded/:platform`} component={SocialExportUploadedPage} />
      <AppRoute path={`${path}/dailymotion/connect`} component={DailymotionApiKeyConnectPage} />
      <AppRoute
        path={`${path}/:platform/settings/:connectionId`}
        component={PlatformSettingsPage}
      />
      <AppRoute path={`${path}/:platform`} component={SocialExportManagePage} />
    </Switch>
  );
}
